// import styled, { keyframes } from 'styled-components';
// import { shade } from 'polished';

// const shine = keyframes`
//   0% {
//     transform: translateX(-120%);
//   }

//   100% {
//     transform: translateX(120%);
//   }
// `;

// export const Container = styled.div`
//   --primary: #ff6d3c;
//   --primary-soft: rgba(255, 109, 60, 0.12);
//   --primary-strong: #e95a2d;
//   --blue: #1789dd;
//   --text: #17263b;
//   --muted: #748196;
//   --border: rgba(216, 224, 235, 0.9);

//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   width: 100%;
//   min-height: 100%;
// `;

// export const LoginCard = styled.div`
//   position: relative;
//   width: 100%;
//   max-width: 468px;
//   margin: 0 auto;
//   padding: 34px;
//   overflow: hidden;
//   border: 1px solid rgba(255, 255, 255, 0.32);
//   border-radius: 32px;
//   background: linear-gradient(
//       180deg,
//       rgba(255, 255, 255, 0.98),
//       rgba(247, 250, 253, 0.94)
//     ),
//     rgba(255, 255, 255, 0.92);
//   backdrop-filter: blur(26px);
//   box-shadow: 0 32px 90px rgba(0, 0, 0, 0.34),
//     0 1px 0 rgba(255, 255, 255, 0.95) inset;

//   &::before {
//     content: '';
//     position: absolute;
//     top: -110px;
//     right: -95px;
//     width: 240px;
//     height: 240px;
//     border-radius: 999px;
//     background: radial-gradient(
//       circle,
//       rgba(255, 109, 60, 0.18),
//       transparent 65%
//     );
//     pointer-events: none;
//   }

//   &::after {
//     content: '';
//     position: absolute;
//     left: -110px;
//     bottom: -120px;
//     width: 250px;
//     height: 250px;
//     border-radius: 68px;
//     background: radial-gradient(
//       circle,
//       rgba(23, 137, 221, 0.14),
//       transparent 68%
//     );
//     transform: rotate(18deg);
//     pointer-events: none;
//   }

//   > form,
//   > div {
//     position: relative;
//     z-index: 1;
//   }

//   > form {
//     width: 100%;
//     display: flex;
//     flex-direction: column;
//   }

//   form > div {
//     width: 100%;
//   }

//   form label {
//     margin-bottom: 8px;
//     color: #253850;
//     font-size: 11px;
//     font-weight: 900;
//     letter-spacing: 0.8px;
//     text-transform: uppercase;
//   }

//   form input {
//     height: 54px;
//     width: 100%;
//     border: 1px solid var(--border);
//     border-radius: 16px;
//     color: #1f2f46;
//     font-size: 15px;
//     padding: 0 16px;
//     outline: none;
//     background: rgba(248, 250, 253, 0.95);
//     box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;
//     transition: border-color 0.22s ease, box-shadow 0.22s ease,
//       background 0.22s ease, transform 0.22s ease;

//     &::placeholder {
//       color: #98a5b7;
//       font-size: 14px;
//     }

//     &:focus {
//       border-color: var(--primary);
//       background: #fff;
//       box-shadow: 0 0 0 4px var(--primary-soft),
//         0 12px 28px rgba(23, 38, 59, 0.08);
//       transform: translateY(-1px);
//     }

//     &.has-error {
//       border-color: #de3b3b;
//       box-shadow: 0 0 0 4px rgba(222, 59, 59, 0.1);
//     }
//   }

//   form span.error {
//     padding-top: 6px;
//     color: #de3b3b;
//     font-size: 11px;
//     font-weight: 800;
//   }

//   button {
//     cursor: pointer;
//   }

//   button#btn-submit {
//     position: relative;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     min-height: 56px;
//     width: 100%;
//     margin-top: 24px;
//     overflow: hidden;
//     border: 0;
//     border-radius: 17px;
//     color: #fff;
//     background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%);
//     box-shadow: 0 18px 38px rgba(255, 109, 60, 0.36),
//       0 1px 0 rgba(255, 255, 255, 0.28) inset;
//     font-size: 15px;
//     font-weight: 900;
//     letter-spacing: 0.2px;
//     transition: transform 0.22s ease, box-shadow 0.22s ease,
//       background 0.22s ease;

//     &::before {
//       content: '';
//       position: absolute;
//       inset: 0;
//       width: 45%;
//       background: linear-gradient(
//         90deg,
//         transparent,
//         rgba(255, 255, 255, 0.28),
//         transparent
//       );
//       transform: translateX(-120%);
//       pointer-events: none;
//     }

//     &:hover {
//       transform: translateY(-2px);
//       background: linear-gradient(
//         135deg,
//         ${shade(0.08, '#ff6d3c')} 0%,
//         #ff784a 100%
//       );
//       box-shadow: 0 22px 44px rgba(255, 109, 60, 0.42),
//         0 1px 0 rgba(255, 255, 255, 0.28) inset;

//       &::before {
//         animation: ${shine} 0.8s ease;
//       }
//     }

//     &:active {
//       transform: translateY(0);
//     }

//     &:disabled {
//       cursor: not-allowed;
//       opacity: 0.72;
//       transform: none;
//       box-shadow: none;
//     }
//   }

//   @media (max-width: 600px) {
//     max-width: 100%;
//     padding: 28px 22px;
//     border-radius: 28px;
//     background: rgba(255, 255, 255, 0.96);
//     box-shadow: 0 26px 70px rgba(0, 0, 0, 0.32),
//       0 1px 0 rgba(255, 255, 255, 0.9) inset;
//   }
// `;

// // export const CardTopbar = styled.div`
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   margin-bottom: 28px;

// //   span {
// //     display: inline-flex;
// //     align-items: center;
// //     gap: 8px;
// //     color: #31465f;
// //     font-size: 12px;
// //     font-weight: 900;
// //     letter-spacing: 0.4px;
// //   }

// //   span::before {
// //     content: '';
// //     width: 9px;
// //     height: 9px;
// //     border-radius: 999px;
// //     background: #22c55e;
// //     box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.12);
// //   }

// //   small {
// //     color: #97a4b5;
// //     font-size: 11px;
// //     font-weight: 800;
// //   }
// // `;

// export const CardTopbar = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   margin-bottom: 28px;

//   span {
//     display: inline-flex;
//     align-items: center;
//     gap: 8px;
//     color: #31465f;
//     font-size: 12px;
//     font-weight: 900;
//     letter-spacing: 0.4px;
//   }

//   span::before {
//     content: '';
//     width: 9px;
//     height: 9px;
//     border-radius: 999px;
//     background: #22c55e;
//     box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.12);
//   }
// `;

// export const BrandLogo = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-bottom: 30px;

//   img {
//     height: auto;
//     width: 148px;
//   }
// `;

// export const LoginHeader = styled.div`
//   margin-bottom: 24px;

//   > span {
//     display: block;
//     margin-bottom: 9px;
//     color: var(--primary);
//     font-size: 12px;
//     font-weight: 950;
//     letter-spacing: 1px;
//     text-transform: uppercase;
//   }

//   h1 {
//     margin: 0;
//     color: var(--text);
//     font-size: 32px;
//     line-height: 1.04;
//     letter-spacing: -0.9px;
//   }

//   p {
//     margin: 12px 0 0;
//     color: var(--muted);
//     font-size: 14px;
//     line-height: 1.65;
//   }

//   @media (max-width: 600px) {
//     h1 {
//       font-size: 28px;
//     }
//   }
// `;

// export const LoginActions = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   margin-top: 4px;

//   button#btn-forgot {
//     border: 0;
//     background: transparent;
//     color: var(--primary);
//     font-size: 13px;
//     font-weight: 900;
//     transition: color 0.22s ease, transform 0.22s ease;

//     &:hover {
//       color: ${shade(0.18, '#ff6d3c')};
//       transform: translateX(2px);
//       text-decoration: underline;
//     }
//   }
// `;

// export const SecurityNote = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 4px;
//   margin-top: 18px;
//   padding: 14px 16px;
//   border: 1px solid rgba(23, 137, 221, 0.14);
//   border-radius: 16px;
//   background: rgba(23, 137, 221, 0.055);

//   strong {
//     color: #253850;
//     font-size: 12px;
//     font-weight: 900;
//   }

//   span {
//     color: #758399;
//     font-size: 12px;
//     line-height: 1.45;
//   }
// `;

// export const Footer = styled.footer`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   margin-top: 26px;
//   gap: 8px;

//   a {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }

//   a img {
//     height: auto;
//     width: 132px;
//     opacity: 0.68;
//     transition: opacity 0.22s ease, transform 0.22s ease;

//     &:hover {
//       opacity: 1;
//       transform: translateY(-1px);
//     }
//   }

//   @media (max-width: 600px) {
//     a img {
//       filter: brightness(0) invert(1);
//       opacity: 0.72;
//     }
//   }
// `;

import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';

const shine = keyframes`
  0%   { transform: translateX(-120%); }
  100% { transform: translateX(120%); }
`;

const cardIn = keyframes`
  from { opacity: 0; transform: translateY(26px) scale(0.985); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const Container = styled.div`
  --primary: #ff6d3c;
  --primary-soft: rgba(255, 109, 60, 0.12);
  --primary-strong: #e95a2d;
  --blue: #1789dd;
  --text: #17263b;
  --muted: #748196;
  --border: rgba(216, 224, 235, 0.9);

  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
`;

export const LoginCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 468px;
  margin: 0 auto;
  padding: 34px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 32px;
  background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.98),
      rgba(247, 250, 253, 0.94)
    ),
    rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(26px);
  box-shadow: 0 32px 90px rgba(0, 0, 0, 0.34),
    0 1px 0 rgba(255, 255, 255, 0.95) inset;
  animation: ${cardIn} 0.75s cubic-bezier(0.22, 1, 0.36, 1) both;

  &::before {
    content: '';
    position: absolute;
    top: -110px;
    right: -95px;
    width: 240px;
    height: 240px;
    border-radius: 999px;
    background: radial-gradient(
      circle,
      rgba(255, 109, 60, 0.18),
      transparent 65%
    );
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    left: -110px;
    bottom: -120px;
    width: 250px;
    height: 250px;
    border-radius: 68px;
    background: radial-gradient(
      circle,
      rgba(23, 137, 221, 0.14),
      transparent 68%
    );
    transform: rotate(18deg);
    pointer-events: none;
  }

  > form,
  > div {
    position: relative;
    z-index: 1;
  }

  > form {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  form > div {
    width: 100%;
  }

  form label {
    margin-bottom: 8px;
    color: #253850;
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }

  form input {
    height: 54px;
    width: 100%;
    border: 1px solid var(--border);
    border-radius: 16px;
    color: #1f2f46;
    font-size: 15px;
    padding: 0 16px;
    outline: none;
    background: rgba(248, 250, 253, 0.95);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;
    transition: border-color 0.22s ease, box-shadow 0.22s ease,
      background 0.22s ease, transform 0.22s ease;

    &::placeholder {
      color: #98a5b7;
      font-size: 14px;
    }

    &:hover:not(:focus) {
      border-color: rgba(255, 109, 60, 0.4);
      background: #fff;
    }

    &:focus {
      border-color: var(--primary);
      background: #fff;
      box-shadow: 0 0 0 4px var(--primary-soft),
        0 12px 28px rgba(23, 38, 59, 0.1);
      transform: translateY(-1px);
    }

    &.has-error {
      border-color: #de3b3b;
      box-shadow: 0 0 0 4px rgba(222, 59, 59, 0.1);
    }
  }

  form span.error {
    padding-top: 6px;
    color: #de3b3b;
    font-size: 11px;
    font-weight: 800;
  }

  button {
    cursor: pointer;
  }

  button#btn-submit {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 56px;
    width: 100%;
    margin-top: 24px;
    overflow: hidden;
    border: 0;
    border-radius: 17px;
    color: #fff;
    background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%);
    box-shadow: 0 18px 38px rgba(255, 109, 60, 0.36),
      0 1px 0 rgba(255, 255, 255, 0.28) inset;
    font-size: 15px;
    font-weight: 900;
    letter-spacing: 0.2px;
    transition: transform 0.22s ease, box-shadow 0.22s ease,
      background 0.22s ease;
    animation: ${fadeIn} 0.6s ease 0.3s both;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      width: 45%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.32),
        transparent
      );
      transform: translateX(-120%);
      pointer-events: none;
    }

    &:hover {
      transform: translateY(-2px);
      background: linear-gradient(
        135deg,
        ${shade(0.08, '#ff6d3c')} 0%,
        #ff784a 100%
      );
      box-shadow: 0 22px 48px rgba(255, 109, 60, 0.46),
        0 1px 0 rgba(255, 255, 255, 0.28) inset;

      &::before {
        animation: ${shine} 0.85s ease;
      }
    }

    &:active {
      transform: translateY(0);
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.72;
      transform: none;
      box-shadow: none;
    }
  }

  @media (max-width: 600px) {
    max-width: 100%;
    padding: 28px 22px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 26px 70px rgba(0, 0, 0, 0.32),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
  }
`;

export const CardTopbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 28px;

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #31465f;
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.4px;
  }

  span::before {
    content: '';
    width: 9px;
    height: 9px;
    border-radius: 999px;
    background: #22c55e;
    box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.12);
  }
`;

export const BrandLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  animation: ${fadeUp} 0.6s ease 0.1s both;

  img {
    height: auto;
    width: 148px;
  }
`;

export const LoginHeader = styled.div`
  margin-bottom: 24px;
  animation: ${fadeUp} 0.6s ease 0.2s both;

  > span {
    display: block;
    margin-bottom: 9px;
    color: var(--primary);
    font-size: 12px;
    font-weight: 950;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  h1 {
    margin: 0;
    color: var(--text);
    font-size: 32px;
    line-height: 1.04;
    letter-spacing: -0.9px;
  }

  p {
    margin: 12px 0 0;
    color: var(--muted);
    font-size: 14px;
    line-height: 1.65;
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 28px;
    }
  }
`;

export const LoginActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;

  button#btn-forgot {
    border: 0;
    background: transparent;
    color: var(--primary);
    font-size: 13px;
    font-weight: 900;
    transition: color 0.22s ease, transform 0.22s ease;

    &:hover {
      color: ${shade(0.18, '#ff6d3c')};
      transform: translateX(2px);
      text-decoration: underline;
    }
  }
`;

export const SecurityNote = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid rgba(23, 137, 221, 0.14);
  border-radius: 16px;
  background: rgba(23, 137, 221, 0.055);

  strong {
    color: #253850;
    font-size: 12px;
    font-weight: 900;
  }

  span {
    color: #758399;
    font-size: 12px;
    line-height: 1.45;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 26px;
  gap: 8px;
  animation: ${fadeIn} 0.6s ease 0.45s both;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a img {
    height: auto;
    width: 132px;
    opacity: 0.68;
    transition: opacity 0.22s ease, transform 0.22s ease;

    &:hover {
      opacity: 1;
      transform: translateY(-1px);
    }
  }

  @media (max-width: 600px) {
    a img {
      filter: brightness(0) invert(1);
      opacity: 0.72;
    }
  }
`;
